module.exports = __webpack_public_path__ + "media/images/subject_img/HISTORY-b31adf352f4e2f17f826e5c2c5e4ea61.jpg";